import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
	'广州万周成方科技有限公司':'广州万周成方科技有限公司',
	'首页':'首页',
	'产品':'产品',
	'专利':'专利',
	'新闻':'新闻',
	'关于':'关于',
	'联系我们':'联系我们',
	'搜索...':'搜索...',
	'抗干扰 抗拒爆 安全高效':'抗干扰 抗拒爆 安全高效',
	'首页介绍':'公司产品为多款有国际专利保护的电子控制模块和有发明专利的配套脚线，该两款产品根据中国民爆行业积累的爆破经验，采用独特的芯片设计、电子点火、大电容储存、盲插接口、过盈防水结构等新技术和工艺，可以匹配中国所有主流雷管生产企业生产的基础雷管。万周公司产品和基础雷管合并后形成的数码电子雷管成品具有超强抗干扰、抗拒爆性能、便于组网排查、生产运输安全高效等特点，特别是针对露天矿山、地下工程、水下工程等特殊复杂项目环境，可以满足全球各种环境爆破场景使用。',
	'万周成方电子控制模块':'万周成方电子控制模块',
	'万周成方电子控制模块介绍':'一款获得独家专利授权生产的电子雷管电子控制模块和配套脚线',
	'核心产品':'核心产品',
	'助力客户实现更高价值':'助力客户实现更高价值',
	'专利认证':'专利认证',
	'办公地点':'办公地点',
	'邮箱':'邮箱',
	'产品中心':'产品中心',
	'产品规格书':'产品规格书',
	'专利资质':'专利资质',
	'发明专利':'发明专利',
	'发明专利介绍':'发明专利是由国家知识产权局（CNIPA）依法授予的最高层级专利保护，它保护的是对产品、方法或其改进所提出的全新的、具有显著技术进步性的技术方案。',
	'实用新型专利证书':'实用新型专利',
	'实用新型专利证书介绍':'实用新型专利是由中国国家知识产权局（CNIPA）依法授予专利申请人的一份官方证明文件。',
	'新闻资讯':'新闻资讯',
	'企业新闻':'企业新闻',
	'查看更多':'查看更多',
	'查看详情':'查看详情',
	'关于我们':'关于我们',
	'我们是谁':'我们是谁',
	'我们是谁介绍':'广州万周成方科技有限公司，是一家从事货物进出口、技术进出口、电子产品销售等业务的公司，成立于2025年，位于广东省广州市。主要产品为一款获得独家专利授权生产的电子雷管电子控制模块和配套脚线。其专利技术是一种新型拆分式数码电子雷管，特别是针对露天矿山、地下工程、水下工程等特殊复杂项目环境，具有超强抗干扰、抗拒爆性能，便于组网排查，生产运输安全高效等特点。',
	'合作伙伴':'合作伙伴',
	'欢迎与我们联系':'欢迎与我们联系',
	'国际':'国际',
	'国内':'国内',
	...zhLocale
}
export default cn;


// WEBPACK FOOTER //
// ./src/utils/i18n/langs/cn.js